import React, { useEffect, useContext, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Footer, Header, Aside, Main } from '../..';
import { AppContext } from '../../../contexts';
import { Box } from '@mui/joy';
import { ModuleMenu, useDrawer } from 'src/mtska-frontend-app-component';
import { useStyleVariableInjector } from 'src/mtska-frontend-app-scaffolding/utils/StyleVariableInjector';

const Full = () => {

    const {
        appConfiguration,
        filterByLegalEntity,
        legalEntityOptions,
        setCurrentModuleName,
        setCurrentModuleNavigationData,
        setCurrentModuleScope,
        userCapabilities,
        settings
    } = useContext(AppContext)
    const { legalEntitySelector } = appConfiguration || {}
    const { active, showLinkedLegalEntity } = legalEntitySelector || {}

    const { injectColorsToDocumentNode } = useStyleVariableInjector();

    const [isOpen, setIsOpen] = useState();
    const location = useLocation();

    const findKeyDeep = (obj, targetKey) => {
        for (const key in obj) {
            if (key === targetKey) {
                return obj[key]; // valore associato alla chiave trovata
            }
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                const result = findKeyDeep(obj[key], targetKey);
                if (result !== undefined) {
                    return result;
                }
            }
        }
        return undefined;
    }

    useEffect(() => {
        for (let [key, module] of Object.entries(appConfiguration.modules.active)) {
            if (!module.hasOwnProperty('menuItemScope') || !module.hasOwnProperty('menuItemName')) continue;

            let moduleMenuGroup = appConfiguration.navigation[module.menuItemScope];
            let moduleMenuItem = (moduleMenuGroup || {})[module.menuItemName]

            if (!moduleMenuItem) {
                //console.info('[AudienceModule] menuItem non trovato nello scope standard:', module.menuItemName);

                // cerco in tutto appConfiguration.navigation per vedere se il modulo è usato sotto uno scope diverso da quello standard, definito a livello di Module.jsx
                moduleMenuItem = findKeyDeep(appConfiguration.navigation, module.menuItemName);
                //console.info('[AudienceModule] menuItem trovato in scope alternativo:', moduleMenuItem);

                moduleMenuGroup = appConfiguration.navigation[moduleMenuItem.scope];
                //console.info('[AudienceModule] menuGroup identificato:', moduleMenuGroup);
            }

            if (moduleMenuItem == undefined) {
                console.info('ERRORE (Full): NON TROVATO', module.menuItemName, ' in ', module.menuItemScope, appConfiguration.navigation, ' Controlla se Module.jsx è fuori sincro con db');
                return;
            }

            if (moduleMenuItem && moduleMenuItem.href.split('?')[0] === location.pathname.split('?')[0]) {
                setCurrentModuleName(moduleMenuItem.title);
                setCurrentModuleScope(moduleMenuItem.scope);
            }
            if (moduleMenuGroup && moduleMenuItem.href.split('?')[0] === location.pathname.split('?')[0]) {
                setCurrentModuleNavigationData(moduleMenuGroup);
            }
        }
    }, [location]);


    const searchParams = new URLSearchParams(document.location.search)
    const { activate, hasRoute } = useDrawer();


    useEffect(() => {
        setIsOpen((sessionStorage.getItem('prefersAsideOpen') === 'true') ?? true);
        if (searchParams.has('drw')) {
            try {
                const drw = searchParams.get("drw");
                const dwrData = JSON.parse(atob(drw));
                const routeName = dwrData.routeName;
                const params = dwrData.params;

                if (hasRoute(routeName)) {
                    activate(routeName, params);
                }
            } catch (error) { }
        }

    }, [])

    const selectedOption = (legalEntityOptions || []).find((option) => option.id === filterByLegalEntity)

    const { name } = selectedOption || {}

    const handleIsOpen = () => {
        setIsOpen(!isOpen);
    }

    injectColorsToDocumentNode(appConfiguration.colors);

    const getDocumentClassName = () => {
        let cn = ['app'];

        cn.push((isOpen) ? 'open' : 'closed');
        cn.push(userCapabilities['auth/role.is_driver'] ? 'driver' : '');
        cn.push(userCapabilities['auth/role.is_carmanager'] ? 'carmanager' : '');
        cn.push(userCapabilities['auth/role.is_fleetmanager'] ? 'fleetmanager' : '');
        cn.push(userCapabilities['auth/role.is_superuser'] ? 'superuser' : '');
        cn.push(showLinkedLegalEntity ? 'expanded' : '');

        cn.filter((cne) => cne !== '');

        return cn.join(' ');
    }

    return (
        <Box className={getDocumentClassName()}>
            <div className="superheader">
                {showLinkedLegalEntity && <div className='current-legal-entity'>
                    Stai lavorando su <b>{name || '...'}</b>
                </div>}
            </div>
            <Aside onOpenLayout={handleIsOpen} options={legalEntityOptions} />
            <Header />
            <ModuleMenu />
            <Main>
                {((active && settings && filterByLegalEntity) || !active || (userCapabilities && userCapabilities['auth/role.is_driver'])) && <Outlet />}
            </Main>
            <Footer />
        </Box>
    );
};

export default Full;
